import classNames from 'classnames'
import { ButtonHTMLAttributes, forwardRef } from 'react'
import { Spinner } from './Spinner'
import styles from './Button.module.css'

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost'
type Size = 'sm' | 'md' | 'lg'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: Size
  loading?: boolean
}

const variantClasses: Record<Variant, string> = {
  primary: styles['primary'] ?? '',
  secondary: styles['secondary'] ?? '',
  danger: styles['danger'] ?? '',
  ghost: styles['ghost'] ?? '',
}

const sizeClasses: Record<Size, string> = {
  sm: styles['sm'] ?? '',
  md: styles['md'] ?? '',
  lg: styles['lg'] ?? '',
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', loading = false, disabled, children, className = '', ...props }, ref) => {
    return (
      <button
        ref={ref}
        disabled={disabled ?? loading}
        className={classNames(styles['button'], variantClasses[variant], sizeClasses[size], className)}
        {...props}
      >
        {loading && <Spinner size="sm" />}
        {children}
      </button>
    )
  },
)
Button.displayName = 'Button'
